<template>
  <h3 class="card-title">
    {{ title }}
  </h3>
</template>

<script lang="ts">
export default {
  name: 'CardTitle',
  props: {
    title: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.card-title {
  color: var(--Button-colors-Secondary-button-text, #191919);
  text-align: center;
  /* Headings/Heading 3 */
  font-family: Arial;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px; /* 116.667% */
  letter-spacing: -0.72px;
  margin: 0;
  padding: 0;
}
</style>
